import React from "react";
import { SelectInput, useTranslate } from "react-admin";

const EpTargetStateInput = (props) => {
  const translate = useTranslate();
  const choices = [
    { id: 1, name: translate("app.state.closed.name"), code: "closed" },
    { id: 2, name: translate("app.state.in_working.name"), code: "in_working" },
    { id: 3, name: translate("app.state.replaced.name"), code: "replaced" },
  ];

  return (
    <SelectInput
      {...props}
      source={props.source}
      choices={choices}
      optionText="name"
      optionValue="code"
      helperText={translate(
        "resources.user-breaks.fields.executive_project_target_state.help"
      )}
    />
  );
};
export default EpTargetStateInput;
